const WBCONST = {
  consolePrefixList: [],
  SIDEBAR_WIDTH_MIN: 82,
  SIDEBAR_WIDTH: 240,
  BUTTON_HEIGHT: 40,

  MAX_PAGE_RESULTS_COUNT: 99999,
  MIN_PAGE_RESULTS_COUNT: 20,
  MAX_PAGE_COUNT: 100,

  BUTTON_RADIUS: 4,
  INPUT_RADIUS: 4,
  INPUT_HEIGHT: 40,
  HEADER_HEIGHT: 66,
  cartImageMaxSize: '10MB',

  INSERT: 'INSERT',
  UPDATE: 'UPDATE',
  DELETE: 'DELETE',
  PHYSICAL_DELETE: 'PHYSICALDELETE',
  LOGICAL_DELETE: 'LOGICALDELETE',

  defaultWidth: 200,
  preferenceTypeGrid: 'GRID',
  authorizedRoles: ['ADMIN', 'MANAGER'],
  openTasks: ['Assigned', 'Created', 'Work in Progress', 'Reopened'],
  openTasksForAll: ['Created'],
  completedTasks: ['Completed'],
  // Statuses that count as "ready for/in testing" — feeds the Dev Completed
  // Tasks group and QA's status-edit permission.
  developmentCompleted: ['Deployed', 'Testing In Progress', 'Development Completed'],
  tasksToReview: ['Cancelled', 'On Hold', 'Clarification Required'],
  openBugs: ['Assigned', 'Work in Progress', 'Reopened'],
  completedBugs: ['Completed'],
  bugsToReview: ['Cancelled', 'On Hold', 'Testing In Progress'],
  groupStatus: ['Open Tasks', 'Dev Completed Tasks', 'Completed Tasks', 'Tasks To Review'],
  testedEnv: ['Dev', 'Demo', 'Test', 'Simulation'],
  openStatusList: ['Assigned', 'Work in Progress', 'Reopened', 'Cancelled', 'on Hold'],
  devCompletedStatusList: ['Testing In Progress'],
  completedStatusList: ['Completed'],
  ignoreCompleteCancelStatus: [
    'Created',
    'Assigned',
    'Work in Progress',
    'Reopened',
    'on Hold',
    'Testing In Progress',
    'Clarification Required',
    'Development Completed',
  ],
  SYSTEM_PREP: 'System Prep',
  ROBOTEON_APP_ISSUES: 'roboteon-app-issues',
  AUTOMATE_APP_ISSUES: 'automate-app-issues',
  PAGE_TYPE: 'bugs',
  STS: 'STS',
  AI4WMS: 'ai4wms',
  ST: 'ST',
  INTERNAL_PROJECTS: ['STS', 'roboteon-app-issues'],
  EXTERNAL_PROJECT_TABS: ['open', 'completed', 'all'],
  imagesTypes: ['png', 'jpg', 'jpeg', 'gif'],
  bugTrackerAuthorizedTeam: 'QA',
  // The backend QA team was split into these sub-teams; the app still
  // treats them as a single 'QA' team everywhere (access control, team
  // icons, filters).
  qaSubTeams: ['QA-MANUAL', 'QA-AUTO', 'QA'],
  tableTestFields: [
    'taskRequestId',
    'taskSummary',
    'screenId',
    'comments',
    'requestorName',
    'assignedTo',
    'devCompletedDate',
    'testedBy',
    'testedStatus',
    'assigneeGroup',
    'priority',
    'category',
    'tags',
    'dateLogged',
    'dueDate',
    'completedDate',
    'completedPercentage',
    'status',
    'add-fe',
    'add-grouped-fe',
    'view-fe',
    'action',
  ],
  tableCommonFields: [
    'taskRequestId',
    'taskSummary',
    'screenId',
    'comments',
    'requestorName',
    'assignedTo',
    'assigneeGroup',
    'priority',
    'status',
    'category',
    'tags',
    'dateLogged',
    'dueDate',
    'devCompletedDate',
    'completedDate',
    'completedPercentage',
    'add-fe',
    'add-grouped-fe',
    'view-fe',
    'billing',
    'action',
  ],
  accepts: ['.png', '.jpg', '.xlsx', '.docx', '.pdf', '.json', '.txt', '.pptx', '.xml', '.sql'],
  STS_TEAM_REPORT: ['Frontend', 'Backend', 'QA', 'DevOps'],
  BUGS_ID: '-app-issues',
  SCREEN_TRACKER_AUTHORIZED_ROLES: ['admin', 'manager', 'lead'],
  SCREEN_TRACKER: 'Screen Tracker',
  DEFAULT_THEME_COLOR: '#185fa5',
  EMAIL_MAPPING_AUTHORIZED_USER: ['ARAVIND', 'PRABEEN'],
  EMAIL_MAPPING_ORG_ID: 'ROBOTEON',
  EMAIL_MAPPING_GROUP_SUFFIX: '_RECEIVER',
  EMAIL_MAPPING_DEFAULT_USER_GROUP: 'RBTADMIN',
};

export default WBCONST;
